// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7osj0","containerInner":"styles_containerInner__eB796"};